import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class OutpostSea3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.OUTPOST_SEA3;
}

export default OutpostSea3PoiTileEntity;
